<script setup lang="ts">
import { MESSAGE_INFO_TYPE } from "~/shared/constants";

const config = useRuntimeConfig();

const { fullPath } = useRoute();

type MessageInfoType =
  (typeof MESSAGE_INFO_TYPE)[keyof typeof MESSAGE_INFO_TYPE];

const { type = "info", fullwidth = true } = defineProps<{
  type?: MessageInfoType;
  fullwidth?: boolean;
}>();

const slot = useSlots();

onMounted(() => {
  if (window.cmtr) {
    // @ts-ignore
    window.cmtr.callDDM("ui_message", {
      ui_message: {
        category: type,
        environment: config.public.stage,
        text: slot.default ? slot.default()[0].children : "N/A",
        referrer: fullPath,
      },
    });
  }
});
</script>

<template>
  <span :class="['info-message', type, { fw: fullwidth }]">
    <IconInfoTick v-if="type === MESSAGE_INFO_TYPE.success" />
    <IconError
      v-else-if="
        type === MESSAGE_INFO_TYPE.warning || type === MESSAGE_INFO_TYPE.error
      "
    />
    <IconLocation v-else-if="type === MESSAGE_INFO_TYPE.location" />
    <IconInfo v-else />
    <slot>Info message</slot>
  </span>
</template>

<style lang="scss">
.info-message {
  p {
    margin: 0 0 var(--space-8) 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

<style scoped lang="scss">
.info-message {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: auto;
  padding: var(--space-8) var(--space-12);
  color: var(--color-message-text);
  font-size: var(--font-size-info);
  line-height: var(--line-height-info);
  text-align: left;
  word-break: break-all;
  border-radius: var(--border-radius);
  transition: var(--transition-all);

  + .info-message {
    margin-top: 16px;
  }

  svg,
  :deep(svg) {
    flex-shrink: 0;
    margin: 1px 10px 0 0;
  }

  &.fw {
    display: flex;
    width: 100%;
  }

  &.success {
    background: var(--color-message-green);

    // color: var(--color-green);
    &:deep(path) {
      fill: var(--color-green);
    }
  }

  &.info {
    background: var(--color-message-blue);

    // color: var(--color-blue);
    &:deep(path) {
      fill: var(--color-blue);
    }
  }

  &.warning {
    background: var(--color-message-yellow);

    // color: var(--color-yellow);
    &:deep(path) {
      fill: var(--color-orange);
    }
  }

  &.error {
    background: var(--color-message-red);

    // color: var(--color-yellow);
    &:deep(path) {
      fill: var(--primary-red);
    }
  }

  &.grey-info {
    background: var(--color-message-grey);

    &:deep(path) {
      fill: var(--primary-black);
    }
  }

  &.grey,
  &.location {
    background: var(--color-message-grey);
  }

  &.old {
    background: var(--color-message-grey);
    border-radius: 0;

    &:deep(path) {
      fill: var(--primary-black);
    }
  }
}
</style>
